import type { Tables, TablesInsert, TablesUpdate } from "@/integrations/supabase/types";
import type { ServiceContext } from "@prolarus/shared";
import {
  tryCreate,
  tryDelete,
  tryGet,
  tryList,
  tryUpdate,
} from "./_shared";

export type Setting = Tables<"settings">;
export type SettingInsert = Omit<TablesInsert<"settings">, "company_id">;
export type SettingUpdate = TablesUpdate<"settings">;

type SettingWithAudit = Setting & {
  created_by_profile: { full_name: string | null } | null;
  updated_by_profile: { full_name: string | null } | null;
};

export const settingsService = {
  get(id: string) {
    return tryGet<Setting>(`/api/settings/${encodeURIComponent(id)}`);
  },

  getByKey(settingKey: string, _companyId: string) {
    return tryGet<Setting>(`/api/settings/by-key/${encodeURIComponent(settingKey)}`);
  },

  list(_companyId: string) {
    return tryList<Setting>("/api/settings");
  },

  listVisible(_companyId: string) {
    return tryList<SettingWithAudit>("/api/settings?visible=true");
  },

  create(data: SettingInsert, _context: ServiceContext) {
    return tryCreate<Setting>("/api/settings", data);
  },

  update(
    id: string,
    data: SettingUpdate,
    _snapshot: Record<string, unknown>,
    _context: ServiceContext,
  ) {
    return tryUpdate<Setting>(`/api/settings/${encodeURIComponent(id)}`, data);
  },

  updateValue(
    id: string,
    settingValue: unknown,
    _oldValue: unknown,
    _context: ServiceContext,
  ) {
    return tryUpdate<Setting>(`/api/settings/${encodeURIComponent(id)}`, {
      setting_value: settingValue,
    });
  },

  delete(id: string, _snapshot: Record<string, unknown>, _context: ServiceContext) {
    return tryDelete(`/api/settings/${encodeURIComponent(id)}`);
  },
};
